// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg
      id="MarkelIcon__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 283.46 211.75"
      {...props}
    >
      <defs>
        <style>
          {".MarkelIcon__cls-1{fill:#ff4e00}.MarkelIcon__cls-2{fill:#424242}"}
        </style>
      </defs>
      <path
        className="MarkelIcon__cls-2"
        d="M208.37 211.75v-44.38h33.3v7.7H217.3v10.51h19.91v7.24H217.3v11.23h24.3v7.7h-33.23Zm75.1 0v-7.76h-23.59v-36.62h-8.93v44.38h32.52Zm-83.73 0-18.22-25.47 17.84-18.91h-10.84l-17.35 18.18h-2.98v-18.18h-8.93v44.38h8.93v-18.92h8.07l13.54 18.92h9.94Zm-150.03 0v-44.38H39.32l-14.16 22.81h-.66l-14.04-22.81H0v44.38h8.72v-31.81l11.9 18.61h8.53l11.9-18.61v31.81h8.65Zm54.9 0-20.03-44.38h-8.63l-19.97 44.38h9.6l3.75-8.85H91.2l3.74 8.85h9.67ZM79.9 177.98h.78l7.27 17.22H72.59l7.3-17.22Zm69.66 33.77-11.1-16.82c.68-.07 1.35-.19 2-.37 6.32-1.78 9.92-6.55 9.92-13.23 0-8.48-6.17-13.96-15.71-13.96h-23.42v44.38h8.93v-16.4h8.8l10.5 16.4h10.09Zm-29.39-36.68h13.39c5.3 0 7.88 2.01 7.88 6.13s-2.83 6.39-7.75 6.39h-13.52v-12.52Z"
      />
      <path
        className="MarkelIcon__cls-1"
        d="M117.87 122.31H80.58V48.36l37.29-14.73v88.68Zm42.51-105.5-37.29 14.75v90.75h37.29V16.81ZM202.89 0 165.6 14.75v107.56h37.29V0Z"
      />
    </svg>
  );
};

const MarkelIcon = Icon;
export default MarkelIcon;
